import * as React from 'react';
import EXIF from "exif-js";
import exif2css from 'exif2css';
import { withTranslation } from "react-i18next";

import * as styles from './style.css';
import { Fragment } from "react";
import { getSizeContain, isChrome } from '../../../../../infrastructure/helpers';
import pinchZoom from '../../../../uq-ui/helpers/pinchZoom';
import Icon from "../../../../icons/Icon";

const isChromeBrowser = isChrome();

class StickersComponentsMediaPhoto extends React.PureComponent {

  _containerRef = null;

  constructor(props) {
    super(props);
    this.state = {
      exifImageStyles: { opacity: 0 },
      imageStyles: {},
      fullscreen: false,
    };
  }

  componentDidMount() {
    this.mounted = true;
    this.converBlobUrlToBase64();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  converBlobUrlToBase64 () {
    const reader = new FileReader();
    fetch(this.props.source)
      .then(r => r.blob())
      .then((blob) => {
        reader.readAsDataURL(blob); 
        reader.onloadend = () => {
          const base64data = reader.result;
          if (this.mounted) { this.setState({ source: base64data}); }  
        }
      });
  }

  onImageClick = () => {
    if (!this.state.fullscreen) { this.setState({ fullscreen: true }); }
  };

  onFullscreenCloseClick = () => {
    this.setState({ fullscreen: false });
  };

  onExifImageLoad = (event) => {
    const image = event.target;
    EXIF.getData(image, () => {
      let exifImageStyles = { opacity: 1 };
      const orientation = EXIF.getTag(image, 'Orientation');
      if (orientation === 8 || orientation === 6) {
        const { transformStrings } = exif2css(orientation);
        exifImageStyles = { opacity: 1, transform: transformStrings.rotate, maxWidth: '250px' };
      }

      this.setState({ exifImageStyles });
    });
  };

  onImageLoad = (event) => {
    const tgt = event.target;
    const cnt = this._containerRef;
    const size = getSizeContain({
      width: tgt.naturalWidth,
      height: tgt.naturalHeight
    }, {
      height: cnt.offsetHeight,
      width: cnt.offsetWidth
    });
    this.setState({ imageStyles: { ...this.state.imageStyles, ...size } });
  };

  onContainerRef = (ref) => {
    this._containerRef = ref;
  };

  onFullscreenImageRef = (ref) => {
    if (ref) { pinchZoom.call(this, ref); };
  }

  _renderWithExif(source) {
    if (this.state.fullscreen) {
      let exifImageStyles = {};
      Object.assign(exifImageStyles, this.state.exifImageStyles)
      exifImageStyles.maxWidth = '100%';
      return (
        <Fragment>
          { this.state.exifImageStyles.opacity === 0 && (
            <div className={styles.loader}>{this.props.t('loading')}</div>
          ) }
          <div className={styles.fullscreenImgContainer}>
            <img src={source}
                 ref={this.onFullscreenImageRef}
                 onLoad={this.onExifImageLoad}
                 style={exifImageStyles}
                 className={styles.fullscreenImg} />
          </div>
        </Fragment>
      );
    } else {
      return (
        <Fragment>
          { this.state.exifImageStyles.opacity === 0 && (
            <div className={styles.loader}>{this.props.t('loading')}</div>
          ) }
          <img src={source}
               onLoad={this.onExifImageLoad}
               style={this.state.exifImageStyles}
               className={styles.img}
               onClick={this.onImageClick} />
        </Fragment>
      );
    }
  }

  _renderWithoutExif(source) {
    if (this.state.fullscreen) {
      return (<div className={styles.fullscreenImgContainer}>
                <img src={source}
                     ref={this.onFullscreenImageRef}
                     onLoad={this.onImageLoad}
                     className={styles.fullscreenImg} />
              </div>);
    } else {
      return (
        <img src={source}
             style={this.state.imageStyles}
             onLoad={this.onImageLoad}
             className={styles.img}
             onClick={this.onImageClick} />
      );
    }
  }
  
  render() {
    const source = this.state.source || this.props.source;
    const bgUrl = this.state.fullscreen ? null : `url(${source})`;
    const iconClassName = this.props.isMemorial ? styles.fullscreenCloseBtn_memorial : styles.fullscreenCloseBtn;
    return (
      <div className={this.props.isMemorial ? styles.container_memorial : styles.container}
           ref={this.onContainerRef}>
        { !isChromeBrowser && this._renderWithoutExif(source) }
        { isChromeBrowser && this._renderWithExif(source) }
        {
          this.state.fullscreen && 
          <Icon name={ this.props.isMemorial ? 'MediaCloseDark' : 'MediaClose' } 
                className={ iconClassName }
                onClick={this.onFullscreenCloseClick} />
        }
        <div style={{ backgroundImage: bgUrl }} className={this.state.fullscreen ? styles.fullscreenImgBg : styles.imgBg}/>
      </div>
    )
  }
}

export default withTranslation('cmp-media-photo')(StickersComponentsMediaPhoto);


// WEBPACK FOOTER //
// ./src/app/modules/stickers/ui/components/media-photo/index.jsx